import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Stethoscope, Users, HeartPulse, UserCircle, MessageSquare } from 'lucide-react';

const QuickAccessFab = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('user') || 'null');
  const isOphtalmoOrAdmin = user && ['ophthalmologist', 'super_admin', 'regional', 'auteur', 'tresorier'].includes(user.role);

  // Hide FAB on admin pages
  if (location.pathname.startsWith('/admin')) return null;

  const items = [
    { icon: Stethoscope, label: 'Annuaire', href: '/annuaire', color: '#35AFE4' },
    ...(isOphtalmoOrAdmin ? [{ icon: MessageSquare, label: 'Messagerie', href: '/messagerie', color: '#10b981' }] : []),
    { icon: Users, label: 'Adhérer', href: '/adhesion', color: '#1e3a5f' },
    { icon: HeartPulse, label: 'Soutenir', href: 'https://www.helloasso.com/associations/sfoalc-société-francaise-des-ophtalmologistes-adaptateurs-de-lentilles-de-contact', external: true, color: '#e84393', pulse: true },
    { icon: UserCircle, label: user ? 'Mon espace' : 'Connexion', href: user ? '/dashboard' : '/auth', color: '#6c5ce7' },
  ];

  return (
    <div className="fixed right-4 sm:right-6 bottom-6 z-50" data-testid="fab-menu">
      {/* Items */}
      <div className={`flex flex-col items-end gap-2.5 mb-3 transition-all duration-300 ${open ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'}`}>
        {items.map((item, i) => {
          const Icon = item.icon;
          const btn = (
            <div key={i} className="flex items-center gap-2 group" style={{ transitionDelay: open ? `${i * 50}ms` : '0ms' }} data-testid={`fab-item-${i}`}>
              <span className="bg-white text-gray-800 rounded-full shadow-lg px-3 py-1.5 text-xs font-bold whitespace-nowrap">
                {item.label}
              </span>
              <div className={`relative w-12 h-12 rounded-full flex items-center justify-center text-white shadow-lg hover:scale-110 transition-transform ${item.pulse ? 'animate-pulse-slow' : ''}`}
                style={{ backgroundColor: item.color }}>
                {item.pulse && (
                  <>
                    <span className="absolute inset-0 rounded-full animate-ping" style={{ background: item.color, opacity: 0.4, animationDuration: '2s' }} />
                    <span className="absolute inset-[-4px] rounded-full" style={{ background: item.color, opacity: 0.15, animation: 'ping 2s cubic-bezier(0,0,0.2,1) infinite', animationDelay: '0.6s' }} />
                  </>
                )}
                <Icon size={18} className="relative z-10" />
              </div>
            </div>
          );
          if (item.external) return <a key={i} href={item.href} target="_blank" rel="noreferrer" onClick={() => setOpen(false)}>{btn}</a>;
          return <Link key={i} to={item.href} onClick={() => setOpen(false)}>{btn}</Link>;
        })}
      </div>

      {/* Toggle */}
      <button onClick={() => setOpen(!open)}
        className="w-14 h-14 rounded-full flex items-center justify-center text-white shadow-2xl hover:scale-110 transition-all ml-auto"
        style={{ background: 'linear-gradient(135deg, #35AFE4, #1e3a5f)' }}
        data-testid="fab-toggle"
        aria-label={open ? "Fermer le menu rapide" : "Menu rapide"}>
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
          className={`transition-transform duration-300 ${open ? 'rotate-45' : ''}`}>
          <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
        </svg>
      </button>
    </div>
  );
};

export default QuickAccessFab;
